// extracted by mini-css-extract-plugin
export var heroHeaderLeft = "s_qV d_gs d_cp";
export var heroHeaderCenter = "s_gt d_gt d_cp d_ds";
export var heroHeaderRight = "s_gv d_gv d_cp d_dt";
export var heroParagraphLeft = "s_qW d_gp d_cs";
export var heroParagraphCenter = "s_gq d_gq d_cs d_ds";
export var heroParagraphRight = "s_gr d_gr d_cs d_dt";
export var heroBtnWrapperLeft = "s_qX d_dZ d_dY d_s d_bw d_bC";
export var heroBtnWrapperCenter = "s_qY d_d0 d_dY d_s d_bw d_bz";
export var heroBtnWrapperRight = "s_qZ d_d1 d_dY d_s d_bw d_bD";
export var overlayBtnWrapper = "s_q0 d_gn d_X d_4 d_5 d_6 d_bk d_b8";
export var design4 = "s_q1 d_gm d_X d_4 d_5 d_bk";
export var heroExceptionSmall = "s_q2 x_q2";
export var heroExceptionNormal = "s_q3 x_q3";
export var heroExceptionLarge = "s_q4 x_q4";
export var Title1Small = "s_q5 x_q5 x_rM x_rN";
export var Title1Normal = "s_q6 x_q6 x_rM x_rP";
export var Title1Large = "s_q7 x_q7 x_rM x_rQ";
export var BodySmall = "s_q8 x_q8 x_rM x_r4";
export var BodyNormal = "s_q9 x_q9 x_rM x_r5";
export var BodyLarge = "s_rb x_rb x_rM x_r6";